export default __webpack_public_path__ + "static/media/GettyImages-584304124-581032cb3df78c2c7349b374.d1f8fa08.webp";